import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Home, ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-primary-50/30 py-12 px-4 sm:px-6 lg:px-8">
      <Helmet>
        <title>Siden blev ikke fundet - Sehested Tømrerfirma ApS</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="max-w-md w-full text-center space-y-6 bg-white p-8 rounded-2xl border border-primary-100 shadow-sm">
        <p className="text-6xl font-extrabold text-brand-600">404</p>
        <h1 className="font-display text-3xl font-bold text-primary-950">Siden blev ikke fundet</h1>
        <p className="text-primary-600 text-sm leading-relaxed">
          Beklager, men den side du leder efter findes ikke eller er blevet flyttet.
        </p>
        <div className="pt-4">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 rounded-lg bg-brand-600 px-5 py-3 text-sm font-semibold text-white shadow-sm hover:bg-brand-700 transition-all duration-200 w-full"
          >
            <Home className="h-4 w-4" />
            Gå til forsiden
          </Link>
        </div>
      </div>
    </div>
  );
}
